import React from 'react';

const ChildrenSilhouette = ({ className = '' }) => (
  <svg viewBox="0 0 600 200" className={className} preserveAspectRatio="xMidYMid meet" aria-label="children on beach">
    <defs>
      <linearGradient id="css-sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#1a3060" />
        <stop offset="100%" stopColor="#2a5080" />
      </linearGradient>
      <linearGradient id="css-sea" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#2d5082" />
        <stop offset="100%" stopColor="#162544" />
      </linearGradient>
      <linearGradient id="css-sand" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#3d6090" />
        <stop offset="100%" stopColor="#2a5080" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="600" height="120" fill="url(#css-sky)" />
    <rect x="0" y="100" width="600" height="50" fill="url(#css-sea)" />
    <rect x="0" y="140" width="600" height="60" fill="url(#css-sand)" />
    {/* Child 1 */}
    <g transform="translate(130,110)">
      <rect x="-3" y="20" width="6" height="35" rx="3" fill="#1a2848" />
      <rect x="-8" y="50" width="4" height="10" rx="2" fill="#1a2848" />
      <rect x="4" y="50" width="4" height="10" rx="2" fill="#1a2848" />
      <circle cx="0" cy="14" r="8" fill="#1a2848" />
      <rect x="-10" y="24" width="6" height="10" rx="3" fill="#1a2848" />
      <rect x="4" y="24" width="6" height="10" rx="3" fill="#1a2848" />
    </g>
    {/* Child 2 holding balloon */}
    <g transform="translate(230,105)">
      <rect x="-3" y="22" width="6" height="38" rx="3" fill="#1a2848" />
      <rect x="-9" y="55" width="5" height="10" rx="2" fill="#1a2848" />
      <rect x="4" y="55" width="5" height="10" rx="2" fill="#1a2848" />
      <circle cx="0" cy="15" r="9" fill="#1a2848" />
      <rect x="6" y="22" width="3" height="22" rx="1.5" fill="#1a2848" />
      <rect x="22" y="10" width="0.8" height="45" fill="#1a2848" opacity="0.7" />
      <ellipse cx="22" cy="6" rx="6" ry="8" fill="#f4a8c0" />
    </g>
    {/* Child 3 sitting */}
    <g transform="translate(350,125)">
      <rect x="-6" y="20" width="12" height="20" rx="4" fill="#1a2848" />
      <rect x="-9" y="38" width="6" height="12" rx="2" fill="#1a2848" />
      <rect x="3" y="38" width="6" height="12" rx="2" fill="#1a2848" />
      <circle cx="0" cy="13" r="9" fill="#1a2848" />
    </g>
    {/* Child 4 with hat */}
    <g transform="translate(460,112)">
      <rect x="-3" y="20" width="6" height="35" rx="3" fill="#1a2848" />
      <rect x="-8" y="50" width="4" height="10" rx="2" fill="#1a2848" />
      <rect x="4" y="50" width="4" height="10" rx="2" fill="#1a2848" />
      <circle cx="0" cy="13" r="8" fill="#1a2848" />
      <rect x="-10" y="6" width="20" height="5" rx="2" fill="#2a3450" />
      <rect x="-6" y="2" width="12" height="6" rx="2" fill="#2a3450" />
    </g>
    {/* Bird */}
    <g transform="translate(380,35)" opacity="0.5">
      <path d="M0 8C4 4 8 4 12 6" stroke="#eef3f7" strokeWidth="1.2" fill="none" />
      <path d="M12 6C16 4 20 4 24 8" stroke="#eef3f7" strokeWidth="1.2" fill="none" />
    </g>
  </svg>
);

export default ChildrenSilhouette;
